import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { TrailerTailForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function EditTrailerTail({ title, subtitle }) {
  const dispatch = useDispatch();
  const [FileOpen, setFileOpen] = useState(false);
  const [file, setFile] = useState([]);
  const { id } = useParams();
  const trailerTail = useSelector((state) => state.trailerTail);
  const trailerTailType = useSelector((state) => state.trailerTailType);
  const {
    formState: { errors },
    handleSubmit,
    setValue,
    watch,
    control,
  } = useForm({
    defaultValues: {
      licence_number: trailerTail.licence_number,
      type: trailerTail.type,
    },
  });

  useEffect(() => {
    dispatch(actions.trailerTailGet(id));
    dispatch(actions.trailerTailTypeAll({ size: null }));
    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      console.log('DATA', data);
      await dispatch(actions.trailerTailPut(id, data));
      await dispatch(actions.trailerTailGet(id));
      alert('สำเร็จ');
    } catch (error) {
      console.log(error);
    }
  };

  if (trailerTail.isLoading || trailerTail.rows) {
    return <Loading />;
  }
  if (!trailerTail.isLoading && trailerTail.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <TrailerTailForm
                control={control}
                Controller={Controller}
                errors={errors}
                trailerTailType={trailerTailType}
                trailerTail={trailerTail}
                watch={watch}
                setValue={setValue}
                file={file}
                setFile={setFile}
                setFileOpen={setFileOpen}
                FileOpen={FileOpen}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  EditTrailerTail.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
  };

  EditTrailerTail.defaultProps = {
    title: '',
    subtitle: '',
  };

  return <Error />;
}
